export const TEST_ID = 'farmsPage';

export const MOCK_FARM = {
    clientId: 'your-client-id',
    id: 'your-farm-id',
    name: 'Farm Test Farm 1'
};
